
export const accounts = {
  'accounts.title': 'Cuentas de Inversión',
  'accounts.subtitle': 'Ver y gestionar sus cuentas de inversión',
  'accounts.loading': 'Cargando cuentas...',
  'accounts.error': 'Error al cargar las cuentas',
  'accounts.noAccounts': 'No se encontraron cuentas de inversión',
  'accounts.accountNumber': 'Número de Cuenta',
  'accounts.balance': 'Saldo',
  'accounts.accountShare': 'Participación de Cuenta',
  'accounts.accountOpen': 'Cuenta Abierta',
  'accounts.broker': 'Corredor',
  'accounts.active': 'Activo',
  'accounts.inactive': 'Inactivo',
  'accounts.pending': 'Pendiente',
  'accounts.closed': 'Cerrado',
  
  // Transactions section
  'accounts.transactions.title': 'Transacciones de Cuenta',
  'accounts.transactions.subtitle': 'Ver su historial de depósitos y retiros',
  'accounts.transactions.loading': 'Cargando transacciones...',
  'accounts.transactions.error': 'Error al cargar las transacciones',
  'accounts.transactions.noTransactions': 'No se encontraron transacciones',
  'accounts.transactions.export': 'Exportar CSV',
  'accounts.transactions.loadMore': 'Cargar Más',
  
  // Table columns
  'accounts.transactions.table.account': 'Cuenta',
  'accounts.transactions.table.date': 'Fecha',
  'accounts.transactions.table.amount': 'Cantidad',
  'accounts.transactions.table.operation': 'Operación',
  
  // Operations
  'accounts.transactions.deposit': 'Depósito',
  'accounts.transactions.withdrawal': 'Retiro',
  
  // Filters
  'accounts.transactions.filters.account': 'Filtrar por Cuenta',
  'accounts.transactions.filters.operation': 'Filtrar por Operación',
  'accounts.transactions.filters.dateFrom': 'Desde Fecha',
  'accounts.transactions.filters.dateTo': 'Hasta Fecha',
  'accounts.transactions.filters.apply': 'Aplicar Filtros',
  'accounts.transactions.filters.reset': 'Restablecer Filtros',
  'accounts.transactions.filters.allAccounts': 'Todas las Cuentas',
  'accounts.transactions.filters.allOperations': 'Todas las Operaciones',
  
  // Add Account section
  'accounts.addAccount.title': 'Agregar Cuenta de Inversión PAMM',
  'accounts.addAccount.subtitle': 'Proporcione el ID de Cuenta PAMM y el Email Asociado',
  'accounts.addAccount.pammAccount': 'Cuenta PAMM',
  'accounts.addAccount.associatedEmail': 'Email Asociado',
  'accounts.addAccount.validateAccount': 'Validar Cuenta',
  'accounts.addAccount.instructionsTitle': 'Siga las siguientes instrucciones para encontrar su Cuenta PAMM',
  'accounts.addAccount.step1.title': 'Iniciar sesión en su cuenta PAMM usando las credenciales recibidas en su email',
  'accounts.addAccount.step1.substep1': 'Busque un email con asunto: "RADEX MARKETS - Successfully joined PAMM of the money manager - The Club Funding Pro"',
  'accounts.addAccount.step1.substep2': 'Abra el enlace proporcionado en el email: https://pamm.radexmarkets.com/app/auth/investor',
  'accounts.addAccount.step2.title': 'Obtenga su ID de Cuenta PAMM del Portal de Radex Markets en el que acaba de iniciar sesión',
  'accounts.addAccount.step2.description': 'El ID de la Cuenta PAMM está resaltado en la imagen de abajo',
  'accounts.addAccount.validation.pammAccountRequired': 'La Cuenta PAMM es requerida',
  'accounts.addAccount.validation.pammAccountInvalid': 'La Cuenta PAMM debe ser un número positivo',
  'accounts.addAccount.validation.emailRequired': 'El Email Asociado es requerido',
  'accounts.addAccount.validation.emailInvalid': 'Por favor ingrese una dirección de email válida',
  'accounts.addAccount.success': 'Cuenta validada exitosamente',
  'accounts.addAccount.error': 'Error al validar la cuenta',
  'accounts.addAccount.validating': 'Validando cuenta...',
  'accounts.addAccount.successDescription': 'Su cuenta de inversión ha sido añadida exitosamente.',
  
  // Error messages
  'accounts.addAccount.messages.success': 'Cuenta validada y añadida exitosamente',
  'accounts.addAccount.messages.missing_fields': 'Por favor complete todos los campos requeridos',
  'accounts.addAccount.messages.account_exists': 'Esta cuenta de inversión ya está registrada',
  'accounts.addAccount.messages.account_already_registered': 'Esta cuenta no puede ser registrada',
  'accounts.addAccount.messages.account_not_active': 'La cuenta no está activa. Por favor asegúrese de que su cuenta esté activa antes de la validación',
  'accounts.addAccount.messages.account_validation_failed': 'Falló la validación de la cuenta. Por favor verifique su número de cuenta y dirección de email',
  'accounts.addAccount.messages.insert_failed': 'Error al registrar la cuenta. Por favor intente nuevamente',
  'accounts.addAccount.messages.server_error': 'Ocurrió un error. Por favor intente nuevamente más tarde',
  'accounts.addAccount.messages.systemError': 'La operación falló, intente más tarde o contacte Atención al Cliente',
  
  // Placeholders
  'accounts.addAccount.placeholders.pammAccount': 'Ingrese ID de Cuenta PAMM',
  'accounts.addAccount.placeholders.associatedEmail': 'Ingrese Email Asociado',
  
  // General
  'accounts.notAvailable': 'No disponible',
  'accounts.addNewAccount': 'Agregar Nueva Cuenta',
};
